import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { IActivityType } from '../locks-type';
import { Utility, resetForm } from 'src/app/shared/utils/utility.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-access-point-filter-actvity',
  templateUrl: './access-point-filter-actvity.component.html',
  styleUrls: ['./access-point-filter-actvity.component.scss'],
})
export class AccessPointFilterActvityComponent implements OnInit {
  formGroup!: FormGroup;
  readonly CONSTANTS = CONSTANTS;
  orignalFormData: string | undefined;

  subscription: Subscription | undefined;
  readonly LANG_CONST = LANG_CONST;
  sharedData?: ISharedData;
  stepper = 1;
  filterActivity!: any;
  isProfileActivityFilter: boolean = false;
  isUnitActivityFilter: boolean = false;
  activityTypes: IActivityType[] = [];

  /**
   * @description constructor injects all necesary services
   * @param { CreateUserComponent } dialogRef
   */
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AccessPointFilterActvityComponent>,
    private localizationService: LocalizationService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) modalData: any
  ) {
    this.filterActivity = {
      users: modalData.users!,
      dates: modalData.dates!,
      lockType:
        modalData.lockType && modalData.lockType.length > 0
          ? [...modalData.lockType!]
          : [],
      lockIds:
        modalData.lockIds && modalData.lockIds.length > 0
          ? [...modalData.lockIds!]
          : [],
      entityType: modalData.entityType,
    };
    this.isProfileActivityFilter = modalData?.isProfileActivityFilter || false;
  }

  /**
   *  @description call when initialize time do necessary feature add
   */
  ngOnInit(): void {
    if (!this.isProfileActivityFilter) {
      this.isUnitActivityFilter = true;
    }
    this.localizationService.setupLocalization();
    this.activityTypes =
      this.filterActivity.entityType === CONSTANTS.ACCESSPOINT
        ? [...Utility.getAccessPointActivityTypes()]
        : [
            ...Utility.getUnitActivityTypes(
              this.translate,
              this.isProfileActivityFilter,
              this.isUnitActivityFilter
            ),
          ];
    this.createControls();
  }

  /**
   * @description Create all child component into parents
   */
  createControls(): void {
    this.formGroup = this.fb.group({
      userName: this.fb.group({
        searchEntity: ['', MFValidators.compose([MFValidators.required])],
      }),
      dateRange: this.fb.group({
        dateTodateFrom: ['', MFValidators.compose([MFValidators.required])],
      }),
      locks: this.fb.group({
        eventType: [[], MFValidators.compose([MFValidators.required])],
      }),
      lockIds: this.fb.group({
        eventTypeIds: [[], MFValidators.compose([MFValidators.required])],
      }),
      entityType: [''],
    });
    //hold previous form state for reset button
    if (this.filterActivity?.users) {
      this.formGroup.controls.userName.patchValue({
        searchEntity: this.filterActivity.users,
      });
    }

    if (this.filterActivity.dates) {
      this.formGroup.controls.dateRange.patchValue({
        dateTodateFrom: this.filterActivity.dates,
      });
    }

    if (this.filterActivity.lockType) {
      this.formGroup.controls.locks.patchValue({
        eventType: this.filterActivity.lockType,
      });
    }
    if (this.filterActivity.lockType) {
      this.formGroup.controls.lockIds.patchValue({
        eventTypeIds: this.filterActivity.lockIds,
      });
      this.activityTypes = this.activityTypes?.map(
        (activityType: IActivityType) => ({
          ...activityType,
          active:
            this.filterActivity.lockIds?.includes(activityType.eventCode) ||
            false,
        })
      );
    }

    if (this.filterActivity.entityType) {
      this.formGroup.controls.entityType.patchValue({
        eventType: this.filterActivity.entityType,
      });
    }

    this.orignalFormData = JSON.stringify(this.formGroup.value);
  }

  submitToParent(): void {
    this.filterActivity = {
      users: this.formGroup.controls?.userName?.value?.searchEntity,
      dates: this.formGroup.controls?.dateRange?.value?.dateTodateFrom,
      lockType: this.formGroup.controls?.locks?.value?.eventType,
      lockIds: this.formGroup.controls?.lockIds?.value?.eventTypeIds,
      cursor: false,
      prepend: false,
    };
    this.dialogRef.close(this.filterActivity);
  }

  /**
   * @description reset all child form and  states
   * @returns void
   */
  formReset(): void {
    this.formGroup.reset();
    this.stepper = 1;
  }

  /**
   * @description: closeDialog function close the dialogRef.
   * @input none
   * @output { void }
   */

  closeDialog() {
    this.dialogRef?.close(undefined);
  }

  /**
   * @description: resetFilterDataresets the data of activities.
   * @input none
   * @output { void }
   */
  resetFilterData() {
    this.activityTypes = this.activityTypes?.map(
      (actvityType: IActivityType) => {
        if (actvityType.active === true) {
          actvityType.active = false;
        }
        return actvityType;
      }
    );
  }
}
